(function HotelSelectRates($, Adzuki)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		Adzuki.onload('HotelBooking/selectRates', function onload()
		{
			var $modal        = $('.modal');
			var $gallery_btn  = $('#hotel-images');
			var hotel_gallery = null;

			$(".label.amenity").click(function showAmenity()
			{
				$modal.find('.modal-title').text('Amenity Information');
				$modal.find('.modal-body').html($(this).data('amenity'));
				$modal.modal('show');
			});

			$('.open-hotel-details').click(function openDetailsModal()
			{
				$modal.find('.modal-dialog').first().addClass('more-hotel-details');
				$modal.find('.modal-title').text('Hotel Details');
				$modal.find('.modal-body').html($('.more-hotel-details-container').html());
				$modal.modal('show');
			});

			$modal.on('hidden.bs.modal', function modalHidden(e) {
				$modal.find('.modal-dialog').first().removeClass('more-hotel-details');
			});

			$gallery_btn.click(function onGalleryClick()
			{
				if (hotel_gallery) {
					hotel_gallery.openGallery();
				}
			});

			// load gallery images
			Adzuki.Ajax.post('/HotelBooking/getGalleryImages')
			.then(function sucess(response) {
				var images         = response;
				var gallery_images = [];

				if (images.length === 0) {
					return;
				}

				$.each(images, function onEachImage(i, image) {
					gallery_images.push({
						src    : image.url,
						thumb  : image.url,
						subHtml: image.caption,
					});
				});

				hotel_gallery = lightGallery($gallery_btn[0], {
					licenseKey       : 'github',
					download         : false,
					plugins          : [lgThumbnail],
					dynamic          : true,
					thumbnail        : true,
					toggleThumb      : true,
					allowMediaOverlap: true,
					dynamicEl        : gallery_images,
				});
			});
		});
	});

}(jQuery, window.Adzuki || {}));
